import { debounce } from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import ENV from "config/Env";
import { ApiInstance } from "utils/Api";

type PasswordStrengthPayload = {
  password: string;
  hash: string;
};

export const usePasswordStrength = (payload: PasswordStrengthPayload) => {
  const { t } = useTranslation();

  const [strength, setStrength] = useState<number | null>(null);

  const checkPasswordStrength = debounce(async () => {
    if (!payload.password || !payload.hash) {
      setStrength(null);
      return;
    }

    try {
      const response = await ApiInstance.post("/password/strength", payload, ENV.authBaseURL);
      setStrength(response.data.strength);
    } catch (_error) {
      setStrength(null);
      toast.error(t("v8_something_went_wrong", "Something went wrong"));
    }
  }, 500);

  useEffect(() => {
    checkPasswordStrength();
  }, [payload]);

  return { strength };
};
